import { useState } from 'react';
import { useEffect } from 'react';
import { Modal, Form, Row, Col } from 'react-bootstrap';
import { upsertMasterDataCountry, getMasterDataEpoAreaCode } from '../../apiCalls';
import { Input, Select } from '../../Input/Input';

const CountryModal = ({ onSave, onCancel, country, onError }) => {
  const [localCountry, setLocalCountry] = useState({});
  const [areaCodes, setAreaCodes] = useState([]);
  const [abbreviationError, setAbbreviationError] = useState('');

  useEffect(() => {
    const fetchAreaCodes = async () => {
      try {
        const response = await getMasterDataEpoAreaCode(1, 1000, 0);
        const codes = response.data || [];
        // Show all area codes, will disable non-visible ones in the dropdown
        setAreaCodes(codes);

        if (country?.areaCode) {
          const matchedCode = codes.find((ac) => ac.areacode === country.areaCode);
          if (matchedCode) {
            setLocalCountry({ ...country, areaCode: matchedCode.id });
          } else {
            setLocalCountry(country);
          }
        } else {
          setLocalCountry(country);
        }
      } catch (err) {
        console.error('Failed to fetch area codes:', err);
        setLocalCountry(country);
      }
    };

    if (country?.id !== undefined) {
      fetchAreaCodes();
    } else {
      setLocalCountry(country);
    }

    setAbbreviationError('');
  }, [country]);

  const validateAbbreviation = (value) => {
    if (!value) {
      setAbbreviationError('');
      return true;
    }

    // Must be exactly 2 characters, non-digit only
    if (value.length > 2) {
      setAbbreviationError('Must be exactly 2 characters');
      return false;
    }

    if (/\d/.test(value)) {
      setAbbreviationError('Cannot contain digits');
      return false;
    }

    setAbbreviationError('');
    return true;
  };

  const handleAbbreviationChange = (e) => {
    const value = e.target.value;
    setLocalCountry((prev) => ({ ...prev, abbreviation: value }));
    validateAbbreviation(value);
  };

  async function submitForm(event) {
    event.preventDefault();

    if (!validateAbbreviation(localCountry.abbreviation)) {
      return;
    }

    try {
      const isNew = localCountry.id === -1;
      const payload = {
        id: isNew ? null : localCountry.id,
        country: localCountry.country,
        abbreviation: localCountry.abbreviation || '',
        areaCode: localCountry.areaCode || '',
        softDelete: 0,
      };

      await upsertMasterDataCountry(payload);
      onSave(isNew);
      onCancel();
    } catch (err) {
      console.log(err);
      if (onError) onError(err.message || 'Failed to save country');
    }
  }

  const isNew = localCountry?.id === -1;

  return (
    <Modal
      show={localCountry?.id !== undefined}
      onHide={onCancel}
      centered
      size="lg"
      contentClassName="editModal"
      dialogClassName="wide-modal"
    >
      <Modal.Header>
        <Modal.Title>{isNew ? 'Add Country' : `Edit: ${localCountry?.country || ''}`}</Modal.Title>{' '}
        <button type="button" class="btn-close" aria-label="Close" onClick={onCancel} />
      </Modal.Header>
      <Form onSubmit={submitForm} className="flex-grow-1 d-flex flex-column">
        <Modal.Body className="flex-grow-1">
          <Row>
            <Col>
              <Input
                name="country"
                type="text"
                label="Country Name"
                required
                value={localCountry?.country || ''}
                onChange={(e) => setLocalCountry((prev) => ({ ...prev, country: e.target.value }))}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Input
                name="abbreviation"
                type="text"
                label="Abbreviation"
                value={localCountry?.abbreviation || ''}
                onChange={handleAbbreviationChange}
                maxLength="2"
                error={abbreviationError}
                info={<span style={{ fontSize: '0.85em', color: '#666' }}>2 characters, no digits</span>}
              />
            </Col>
            <Col>
              <Select
                label="Area Code"
                data={localCountry?.areaCode || ''}
                setData={(value) => setLocalCountry((prev) => ({ ...prev, areaCode: value }))}
                options={areaCodes.map((ac) => ({
                  id: ac.id,
                  data: ac.areacode,
                  disabled: !ac.isVisible, // Disable options where isVisible is false
                }))}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer
          class="d-flex flex-row py-3 px-3 gap-3 border-top bg-light justify-content-end align-items-center"
          style={{ borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}
        >
          <button
            type="button"
            class="cancel-button"
            onClick={onCancel}
            style={{ display: 'flex', borderRadius: '10px' }}
          >
            Cancel
          </button>
          <button type="submit" class="blue-button-teams green-btn" style={{ borderRadius: '10px' }}>
            {isNew ? 'Add' : 'Save'}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
export default CountryModal;
